"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DeleteButton = _interopRequireDefault(require("../../../../../../components/crud/DeleteButton"));

var _KycProcessModel = _interopRequireDefault(require("../../../models/KycProcessModel"));

var _UserModel = _interopRequireDefault(require("../../../models/UserModel"));

var _DateHelper = _interopRequireDefault(require("../../../../../../util/DateHelper"));

var _config = _interopRequireDefault(require("../../../../../../config"));

var _reactRedux = require("react-redux");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var KYC = /*#__PURE__*/function (_Component) {
  _inherits(KYC, _Component);

  function KYC(props) {
    var _this;

    _classCallCheck(this, KYC);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KYC).call(this, props));
    _this.state = {
      process: null,
      documents: [],
      flowItems: [],
      showModal: false,
      downloadedFiles: {}
    };
    return _this;
  }

  _createClass(KYC, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._loadData();
    }
  }, {
    key: "_loadData",
    value: function _loadData() {
      var _this2 = this;

      var id = this.props.user.id;

      if (id) {
        new _KycProcessModel["default"]().getLatestKycProcess(id).then(function (result) {
          _this2.setState({
            process: result
          }, function () {
            if (result) {
              _this2._loadDocuments(result.id);

              _this2._loadFlow(result.id);
            }
          });
        });
      }
    }
  }, {
    key: "_loadDocuments",
    value: function () {
      var _loadDocuments2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var documents;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _KycProcessModel["default"]().getDocuments(id);

              case 2:
                documents = _context.sent;

                this._downloadFiles(documents);

                this.setState({
                  documents: documents
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _loadDocuments(_x) {
        return _loadDocuments2.apply(this, arguments);
      }

      return _loadDocuments;
    }()
  }, {
    key: "_loadFlow",
    value: function () {
      var _loadFlow2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var flowItems;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new _KycProcessModel["default"]().getFlowItems(id);

              case 2:
                flowItems = _context2.sent;
                this.setState({
                  flowItems: flowItems
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _loadFlow(_x2) {
        return _loadFlow2.apply(this, arguments);
      }

      return _loadFlow;
    }()
  }, {
    key: "_downloadFiles",
    value: function _downloadFiles(documents) {
      var _this3 = this;

      documents.forEach(function (document) {
        var headers = new Headers();
        headers.append('Authorization', 'Bearer ' + _this3.props.token);
        fetch(_config["default"].publicUrl + document.preview, {
          headers: headers
        }).then(function (response) {
          return response.blob();
        }).then(function (blobby) {
          var objectUrl = window.URL.createObjectURL(blobby);

          _this3.setState({
            downloadedFiles: _objectSpread({}, _this3.state.downloadedFiles, _defineProperty({}, document.id, objectUrl))
          });
        });
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "onApproveUser",
    value: function onApproveUser(id) {
      var _this4 = this;

      new _UserModel["default"]().approve(id).then(function () {
        _this4._refresh();
      })["catch"](function () {});
    }
  }, {
    key: "onRejectUser",
    value: function onRejectUser(id) {
      var _this5 = this;

      new _UserModel["default"]().reject(id).then(function () {
        _this5._refresh();
      })["catch"](function () {});
    }
  }, {
    key: "triggerKYC",
    value: function triggerKYC(id) {
      var _this6 = this;

      this.loadingOn();
      new _UserModel["default"]().triggerKYC(id).then(function () {
        _this6._refresh();
      })["catch"](function () {})["finally"](function () {
        _this6.loadingOff();
      });
    }
  }, {
    key: "triggerPEP",
    value: function triggerPEP(id) {
      var _this7 = this;

      this.loadingOn();
      new _UserModel["default"]().triggerPEP(id).then(function () {
        _this7._refresh();
      })["catch"](function () {})["finally"](function () {
        _this7.loadingOff();
      });
    }
  }, {
    key: "triggerSIS",
    value: function triggerSIS(id) {
      var _this8 = this;

      this.loadingOn();
      new _UserModel["default"]().triggerSIS(id).then(function () {
        _this8._refresh();
      })["catch"](function () {})["finally"](function () {
        _this8.loadingOff();
      });
    }
  }, {
    key: "trigerEKYC",
    value: function trigerEKYC(id) {
      var _this9 = this;

      this.loadingOn();
      new _UserModel["default"]().triggerEKYC(id).then(function () {
        _this9._refresh();
      })["catch"](function () {})["finally"](function () {
        _this9.loadingOff();
      });
    }
  }, {
    key: "loadingOn",
    value: function loadingOn() {
      this.setState({
        loading: true
      });
    }
  }, {
    key: "loadingOff",
    value: function loadingOff() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: "_refresh",
    value: function _refresh() {
      this._loadData();

      this.props.onRefresh();
    }
  }, {
    key: "_renderDocuments",
    value: function _renderDocuments() {
      var _this10 = this;

      if (!this.state.process) {
        return null;
      }

      var elements = [];
      this.state.documents.forEach(function (document, index) {
        elements.push(_react["default"].createElement("div", {
          className: "dark-well"
        }, _react["default"].createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'row'
          }
        }, _react["default"].createElement("div", {
          style: {
            display: 'inline-block',
            width: 200,
            height: 150,
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
            backgroundImage: 'url("' + _this10.state.downloadedFiles[document.id] + '")'
          }
        }), _react["default"].createElement("div", {
          style: {
            flex: 1,
            padding: '0 10px'
          }
        }, _react["default"].createElement("h6", null, "Name: ", document.fileName), _react["default"].createElement("h6", null, "Type: ", document.type), _react["default"].createElement("h6", null, _react["default"].createElement("a", {
          className: "button-danger",
          target: "_blank",
          href: _this10.state.downloadedFiles[document.id],
          download: document.fileName
        }, "Download"))))));
      });
      return elements;
    }
  }, {
    key: "_renderFlow",
    value: function _renderFlow() {
      if (!this.state.process) {
        return null;
      }

      var elements = [];
      this.state.flowItems.forEach(function (action, index) {
        elements.push(_react["default"].createElement("div", {
          className: "dark-well",
          style: {
            marginBottom: 10
          }
        }, _react["default"].createElement("div", null, _react["default"].createElement("div", {
          style: {
            marginBottom: 10,
            display: 'flex',
            width: '100%',
            flexDirection: 'row'
          }
        }, _react["default"].createElement("div", {
          style: {
            flex: 1
          }
        }, _react["default"].createElement("h6", null, _react["default"].createElement("strong", null, "Date: "), (0, _moment["default"])(action.created).format('DD/MM/YYYY HH:mm:ss'))), _react["default"].createElement("div", {
          style: {
            flex: 1,
            textAlign: 'right'
          }
        }, _react["default"].createElement("h6", null, _react["default"].createElement("strong", null, "Initiator: "), action.triggeredBy ? _react["default"].createElement("a", {
          style: {
            textDecoration: 'underline'
          },
          href: '/users/all-users/details/' + action.triggeredBy.id,
          target: "_blank"
        }, action.triggeredBy.fullName) : 'System'))), _react["default"].createElement("h6", {
          style: {
            fontSize: '1.2em',
            fontWeight: 'bold'
          }
        }, action.message))));
      });
      return elements;
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      var process = this.state.process;
      var user = this.props.user;
      var kycStatus = user.kycStatus || '';
      var newKycStatus = kycStatus.replace(/#|_/g, ' '); // let items =  this._renderRequests();
      // let items = this.renderRequests();

      return _react["default"].createElement("div", {
        className: "main"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "customers-info"
      }, _react["default"].createElement("div", {
        className: "customer-details"
      }, _react["default"].createElement("div", null, _react["default"].createElement("h2", {
        className: "customer-name"
      }, _react["default"].createElement("span", {
        className: "company"
      }, user.fullName, ": ", kycStatus.toUpperCase()))), _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "bottom",
        style: {
          alignItems: 'center'
        }
      }))), _react["default"].createElement("div", {
        className: "customers-main"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("div", {
        className: "padded"
      }, _react["default"].createElement("div", {
        className: "row text-white"
      }, _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        },
        className: "col-lg-6"
      }, _react["default"].createElement("h4", null, "Latest KYC Process"), _react["default"].createElement("hr", null), process ? _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "State:"), _react["default"].createElement("dd", null, process.state.toUpperCase()), _react["default"].createElement("dt", null, "Status:"), _react["default"].createElement("dd", null, process.status.toUpperCase()), _react["default"].createElement("dt", null, "Started:"), _react["default"].createElement("dd", null, _DateHelper["default"].date(process.created, 'D/MM/Y. H:mm:ss'))) : _react["default"].createElement("em", null, "No latest KYC process"), _react["default"].createElement("div", {
        style: {
          marginTop: 20
        }
      }, _react["default"].createElement("h4", null, "Address Info"), _react["default"].createElement("hr", null), process ? _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "First Name:"), _react["default"].createElement("dd", null, process.firstName), _react["default"].createElement("dt", null, "Last Name:"), _react["default"].createElement("dd", null, process.lastName), _react["default"].createElement("dt", null, "Address Line One:"), _react["default"].createElement("dd", null, process.addressOne), _react["default"].createElement("dt", null, "Address Line Two:"), _react["default"].createElement("dd", null, process.addressTwo), _react["default"].createElement("dt", null, "City:"), _react["default"].createElement("dd", null, process.city), _react["default"].createElement("dt", null, "Postcode:"), _react["default"].createElement("dd", null, process.postCode), _react["default"].createElement("dt", null, "Country:"), _react["default"].createElement("dd", null, process.country ? process.country.name : '-')) : _react["default"].createElement("em", null, "No address info")), _react["default"].createElement("div", {
        style: {
          marginTop: 20
        }
      }, _react["default"].createElement("h4", null, "Documents"), _react["default"].createElement("hr", null), this._renderDocuments())), _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        },
        className: "col-lg-6"
      }, _react["default"].createElement("h4", null, "KYC"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "Status:"), _react["default"].createElement("dd", null, newKycStatus.toUpperCase())), _react["default"].createElement("div", {
        style: {
          margin: 'auto 0 auto auto',
          textAlign: 'right'
        }
      }, user.kycStatus === 'approved' ? _react["default"].createElement(_DeleteButton["default"], {
        btnText: 'Reject',
        onConfirm: function onConfirm() {
          return _this11.onRejectUser(user.id);
        },
        text: 'Are you sure you wish to reject this user "' + user.fullName + '"?'
      }) : _react["default"].createElement(_DeleteButton["default"], {
        className: "button-info",
        btnText: 'Approve',
        onConfirm: function onConfirm() {
          return _this11.onApproveUser(user.id);
        },
        text: 'Are you sure you wish to approve this user "' + user.fullName + '"?'
      }), _react["default"].createElement("div", {
        style: {
          marginTop: 5
        }
      }, _react["default"].createElement(_DeleteButton["default"], {
        style: {
          display: 'inline-block',
          marginRight: 5
        },
        className: "button-danger",
        btnText: 'Trigger full KYC',
        onConfirm: function onConfirm() {
          return _this11._triggerFullKYC(user.id);
        },
        text: 'Are you sure you wish to trigger KYC check for user "' + user.fullName + '"?'
      }), _react["default"].createElement(_DeleteButton["default"], {
        style: {
          display: 'inline-block',
          marginRight: 5
        },
        className: "button-info",
        btnText: 'Trigger PEP check',
        onConfirm: function onConfirm() {
          return _this11._triggerPEP(user.id);
        },
        text: 'Are you sure you wish to trigger PEP check for user "' + user.fullName + '"?'
      }), _react["default"].createElement(_DeleteButton["default"], {
        style: {
          display: 'inline-block',
          marginRight: 5
        },
        className: "button-info",
        btnText: 'Trigger SIS check',
        onConfirm: function onConfirm() {
          return _this11._triggerSIS(user.id);
        },
        text: 'Are you sure you wish to trigger SIS check for user "' + user.fullName + '"?'
      }), _react["default"].createElement(_DeleteButton["default"], {
        style: {
          display: 'inline-block'
        },
        className: "button-info",
        btnText: 'Trigger eKYC',
        onConfirm: function onConfirm() {
          return _this11._trigerEKYC(user.id);
        },
        text: 'Are you sure you wish to trigger eKYC for user "' + user.fullName + '"?'
      }))), _react["default"].createElement("div", {
        style: {
          marginTop: 20
        }
      }, _react["default"].createElement("h4", null, "KYC FLOW"), _react["default"].createElement("hr", null), this._renderFlow()))), _react["default"].createElement("div", {
        className: "row text-white"
      })))))));
    }
  }]);

  return KYC;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    token: state.auth.token
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(KYC);

exports["default"] = _default;